import React from "react";
import { Grid, Button, Box, Typography } from "@material-ui/core";
import { Brightness1Rounded, InsertChartRounded } from "@material-ui/icons";
import { navigate } from "@reach/router";
import moment from "moment";

import DataTable from "../Custom/DataTable";

/**
|--------------------------------------------------
| Default Props
|--------------------------------------------------
*/
SensorBoardTable.defaultProps = {
  sensors: [],
};

export default function SensorBoardTable(props) {
  /**
  |--------------------------------------------------
  | Props
  |--------------------------------------------------
  */
  const { sensors, dealerID, factoryID } = props;

  /**
  |--------------------------------------------------
  | Table Columns
  |--------------------------------------------------
  */
  const columns = [
    {
      Header: "STATUS",
      accessor: "message",
      Cell: ({ cell: { row } }) => (
        <Grid container justify="flex-end">
          {row.original.message === "online" && (
            <Grid container>
              <Box color="green.500" mr={2}>
                <Brightness1Rounded color="inherit" />
              </Box>
              <Typography>Online</Typography>
            </Grid>
          )}
          {row.original.message === "offline" && (
            <Grid container>
              <Box color="grey.900" mr={2}>
                <Brightness1Rounded color="inherit" />
              </Box>
              <Typography>Offline</Typography>
            </Grid>
          )}
        </Grid>
      ),
    },
    {
      Header: "NAME",
      accessor: "name",
    },
    {
      Header: "LAST UPDATE",
      accessor: "lastupdate",
      Cell: ({ cell: { value } }) =>
        moment(value).format("DD MMM YYYY HH:mm:ss"),
    },
    {
      Header: " ",
      Cell: ({ cell: { row } }) => (
        <Grid container justify="flex-end">
          <Box mr={2}>
            <Button
              variant="contained"
              onClick={() =>
                navigate(`/${dealerID}/${factoryID}/${row.original.id}`)
              }
            >
              Dashboard
            </Button>
          </Box>
        </Grid>
      ),
    },
  ];

  const columnsMobile = [
    {
      Header: "NAME",
      accessor: "name",
      Cell: ({ cell: { row } }) => (
        <div>
          {row.original.message === "online" && (
            <div className="flex flex-row">
              <Box color="green.500" mr={2}>
                <Brightness1Rounded color="inherit" />
              </Box>
              <Box>{row.original.name}</Box>
            </div>
          )}
          {row.original.message === "offline" && (
            <div className="flex flex-row">
              <Box color="grey.900" mr={2}>
                <Brightness1Rounded color="inherit" />
              </Box>
              <Box>{row.original.name}</Box>
            </div>
          )}
        </div>
      ),
    },
    {
      Header: " ",
      Cell: ({ cell: { row } }) => (
        <div className="flex flex-row">
          <Button
            variant="text"
            onClick={() =>
              navigate(`/${dealerID}/${factoryID}/${row.original.id}`)
            }
          >
            <InsertChartRounded />
          </Button>
        </div>
      ),
    },
    {
      Header: "LAST UPDATE",
      accessor: "lastupdate",
      Cell: ({ cell: { value } }) => (
        <div className="flex flex-col">
          {moment(value).format("DD MMM YYYY")}
          <br />
          {moment(value).format("HH:mm:ss")}
        </div>
      ),
    },
  ];

  /**
  |--------------------------------------------------
  | Render
  |--------------------------------------------------
  */
  return (
    <DataTable
      columns={props.isMobile ? columnsMobile : columns}
      data={sensors}
    />
  );
}
